import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Home from "../src/Component/Home";
import Header from "../src/Component/Header";
import Registration from "../src/Component/Registration";
import Input from "../src/Component/Input";
import Admin from "../src/Component/Admin";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// создаём кастомную историю

ReactDOM.render(
  <React.StrictMode>
   <Router>
          <Switch>
          <Route exact path="/" component={Home} />
            <Route exact path="/registration" component={Registration} />
            <Route exact path="/input" component={Input} />
            <Route exact path="/admin" component={Admin} />
          </Switch>
        </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
